import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Button, Container, Col, Row, Label, Input, FormGroup } from 'reactstrap';
import ModalForm from '../../../comum/components/ModalForm';
import Checkbox from '../../../comum/components/Checkbox';
import DataWrapper from '../../../principal/containers/DataWrapper';
import Footer from '../../../comum/components/Footer';
import IconeCarregar from '../../../comum/components/Icones';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlteraDtaDtcStore from '../store/AlteraDtaDtcStore';
import ModalAviso from '../../../comum/components/ModalAviso';

@inject('store')
@DataWrapper
@observer

export class AlteraDtaDtc extends Component {

    constructor(props) {
        super(props);

        this.controller = new AlteraDtaDtcStore()

        this.state = {
            showModalTermosAlteracao: false,
            showModalErros: false,
            showModalFinalizacao: false,
            termosAceitos: false,
            erros: []
        }

        this.appStore = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Alteração de DTA Pátio e DTC");
    
        let voltarParam = _.get(this.props.location.state, `voltar`);
    
        this.appStore.showTopbar(true);
        this.appStore.showVoltarTopBar(
          voltarParam ? true : false,
          voltarParam ? voltarParam : "/"
        );
    }

    onBlurCobrarDe = async () => {
        try{
            await this.controller.onBlurCobrarDe();
        }catch(err){
            console.log(err);
            this.setState({ erros: [err], showModalErros: true })
        }
    }

    handleFinalizar = async () => {

        try{

            let erros = [];

            if(!this.controller.documento)
                erros.push('Preencha o documento que deseja alterar.');

            if(!this.controller.codigocobrarde)
                erros.push('Selecione o parceiro comercial.');
        
            if(!this.state.termosAceitos)
                erros.push('Você precisa concordar com os termos para continuar com a alteração.');

            if(erros.length == 0){

                erros = await this.controller.handleFinalizar();

                if(erros.length > 0){
                    this.setState( {erros, showModalErros: true });
                }else{
                    this.setState({ showModalFinalizacao: true });
                }
            }else{
                this.setState( {erros, showModalErros: true });
            }
        }catch(err){
            console.log(err);
            this.setState({ erros: [err], showModalErros: true });
        }
    }

    AbrirTermoAlteracao = () => {
        this.setState({ showModalTermosAlteracao: true })
    }

    FecharTermoAlteracao = () => {
        this.setState({ showModalTermosAlteracao: false, termosAceitos: false });
    }

    AceitarTermoAlteracao = () => {
        this.setState({ showModalTermosAlteracao: false, termosAceitos: true });
    }

    OnChangeTermoAlteracao =() => {
        this.setState({ termosAceitos: !this.state.termosAceitos });
    }

    modalTermoAlteracao = () => {
        return (
            this.state.showModalTermosAlteracao &&
            <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="LI E ACEITO OS TERMOS"
                labelCancelar="Cancelar"
                onClickSalvar={() => this.AceitarTermoAlteracao()}
                onClickCancelar={() => this.FecharTermoAlteracao()}
            >
                <h2>Termos de Alteração</h2>
                <span>
                Declaro, sob as penas da lei, serem verdadeiras as informações neste ato prestadas, tendo ciência que a identificação 
                de irregularidade poderá ensejar em medidas cíveis, penais e de responsabilização cabíveis, quando tipificadas em Lei, 
                e que tenho total conhecimento que a tipificação e penalidades do artigo 299 do Código Penal Brasileiro também são aplicáveis 
                na relação entre entes privados, aquiescendo com todas as responsabilidades inerentes às informações ora prestadas, 
                bem como das implicações legais decorrentes do seu uso indevido, seja qual for a circunstância.
                </span>
            </ModalForm>
        );
    }

    modalErro = () => {
        return (
            this.state.showModalErros &&
            <ModalAviso
                onClickFechar = {()=>{ this.setState({erros: [], showModalErros: false }) }}
            >
                { this.state.erros.map((x) =>
                    <h2 key={x}>{ x }</h2>
                )}
                
            </ModalAviso>
        );
    }

    modalFinalizacao = () => {
        return (
            this.state.showModalFinalizacao &&
            <ModalAviso
                onClickFechar = {()=>{ 
                    this.setState({showModalFinalizacao: false });
                    window.location.reload();
                }}
            >
                <h2>As alterações foram salvas.</h2>
            </ModalAviso>
        );
    }

    render() {
        return (
            this.modalFinalizacao() ||
            this.modalErro() ||
            this.modalTermoAlteracao() ||
            <div className="form-wrapper">
                <Container fluid>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup className="form-group has-feedback">
                            <Label className="">Documento</Label>
                            <Input
                                value={this.controller.documento}
                                onChange={(event) =>
                                    this.controller.setDocumento(event.target.value)
                                }
                            />
                        </FormGroup>
                        <FormGroup className="form-group has-feedback">
                            <Label className="">{ this.controller.labelcobrarde }</Label>
                            <Input
                                value={this.controller.cobrarde}
                                onChange={(event) =>
                                    this.controller.setCobrarDe(event.target.value)
                                }
                                onBlur={this.onBlurCobrarDe}
                            />
                        </FormGroup>
                        <div className="modal-termos-alteracao">
                            <div>
                                <span> 
                                    Declaro estar de acordo com os <span className="link link--underline" onClick={this.AbrirTermoAlteracao}>termos de alteração</span>.
                                </span>
                            </div>                                
                            <Checkbox onClick={this.OnChangeTermoAlteracao} 
                                    ativo={this.state.termosAceitos ? true : false} 
                                    bloqueado={false}
                            />
                        </div>
                        
                    </Col>
                </Row>
                </Container>
                <Footer className="footer-opcoes justify-content-between">
                    <Row>
                        <Col xs={"auto"} xl={2} className="ml-auto ml-2">
                            {!this.controller.carregar
                                ? <div><Button className="btn-primary" onClick={this.handleFinalizar}>CONFIRMAR ALTERAÇÃO</Button></div>
                                : <FontAwesomeIcon icon="circle-notch" size={"2x"} className={"icone"} color={"#001C43"} spin />
                            }
                        </Col>
                    </Row>
                </Footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/dtadtc/telas/AlteraDtaDtc.js